import { styled, ToggleButtonGroup, ToggleButtonGroupProps } from '@mui/material';
import { forwardRef } from 'react';

import { colorSystem } from '../../theme';

const DefaultToggleButton = styled(ToggleButtonGroup)({
    height: 32,
    backgroundColor: colorSystem.neutral[2],
    padding: 4,
    gap: 4,
    boxSizing: 'border-box',
    // MUI v9 joins grouped buttons into one segment; undo that for separate pills.
    '& .MuiToggleButtonGroup-grouped': {
        margin: 0,
        border: 0,
        borderRadius: 4,
    },
    '& .MuiToggleButtonGroup-firstButton, & .MuiToggleButtonGroup-middleButton, & .MuiToggleButtonGroup-lastButton': {
        marginLeft: 0,
        borderLeft: 0,
        borderRadius: 4,
    },
});

export const ToggleButton = forwardRef(function ToggleButton(
    { ...props }: ToggleButtonGroupProps,
    ref: React.ForwardedRef<unknown>,
): JSX.Element {
    return (
        <DefaultToggleButton ref={ref} {...props}>
            {props.children}
        </DefaultToggleButton>
    );
});
